// extracted by mini-css-extract-plugin
export const txtMaxCashback = "styles-module--txtMaxCashback--2ofA9";
export const oldCashback = "styles-module--oldCashback--Ia6G5";
export const newCashback = "styles-module--newCashback--h71qh";